import { formatTanggalID } from "../utils/hariKerja";

export function buildWATemplate({ jenis, kasus, terperiksa, sisaHK }) {
  const header = `Yth. Bapak/Ibu ${terperiksa?.namaPejabat || terperiksa?.namaInstansi || ""}`.trim();
  const lhp = kasus.nomorLHP || "(no. LHP)";
  const judul = kasus.judulKasus || "-";

  const body = `Kami mengingatkan bahwa LHP No: ${lhp}\nJudul: ${judul}\n\nSaat ini sisa waktu tindak lanjut adalah *${sisaHK} Hari Kerja*.`;

  return [header, "", body].join("\n");
}

/**
 * Template WA untuk notifikasi penyerahan laporan ke TERPERIKSA.
 * Dikirim saat tanggal penyerahan laporan diisi/disimpan.
 */
export function buildWAPenyerahanTerperiksa({ kasus, terperiksa }) {
  const lhp = kasus.nomorLHP || "(no. LHP)";
  const tglSerah = formatTanggalID(kasus.tanggalPenyerahanLaporan);
  const deadline60 = formatTanggalID(kasus.deadlineTL60HK);
  const header = `Yth. ${terperiksa?.namaPejabat || "Bapak/Ibu"}\n${terperiksa?.jabatan || ""} - ${terperiksa?.namaInstansi || "-"}`;
  const body =
    `Dengan hormat,\n\n` +
    `Bersama ini kami sampaikan bahwa Laporan Hasil Pemeriksaan (LHP) dengan:\n` +
    `- Nomor LHP   : ${lhp}\n` +
    `- Judul       : ${kasus.judulKasus || "-"}\n` +
    `- Tgl Serah   : ${tglSerah}\n\n` +
    `telah diserahkan kepada Saudara/i.\n\n` +
    `Sesuai ketentuan, Saudara/i WAJIB menyelesaikan seluruh Tindak Lanjut rekomendasi paling lambat:\n\n` +
    `📅 *${deadline60}* (60 Hari Kerja)\n\n` +
    `Mohon segera koordinasikan tindak lanjut dengan tim pemeriksa.\n` +
    `Terima kasih atas perhatian dan kerjasamanya.`;
  const footer = `\n- Irbansus Inspektorat Kab. Tasikmalaya`;
  return [header, "", body, footer].join("\n");
}

/**
 * Template WA untuk notifikasi internal ke Tim Pemeriksa / Irban / Dalnis / Anggota.
 * Dikirim bersamaan dengan notif ke terperiksa.
 */
export function buildWAPenyerahanTim({ kasus, namaAnggota, roleAnggota }) {
  const lhp = kasus.nomorLHP || "(no. LHP)";
  const tglSerah = formatTanggalID(kasus.tanggalPenyerahanLaporan);
  const deadline60 = formatTanggalID(kasus.deadlineTL60HK);
  const terperiksa = (kasus.terperiksa || []).map((t) => `${t.namaPejabat || "-"} (${t.namaInstansi || "-"})`).join(", ") || "-";
  const header = `Yth. ${namaAnggota || "Tim Pemeriksa"} (${roleAnggota || ""})`;
  const body =
    `Informasi Penyerahan LHP:\n\n` +
    `- Nomor LHP   : ${lhp}\n` +
    `- Judul       : ${kasus.judulKasus || "-"}\n` +
    `- Tgl Serah   : ${tglSerah}\n` +
    `- Terperiksa  : ${terperiksa}\n\n` +
    `Batas waktu Tindak Lanjut 60 Hari Kerja:\n` +
    `📅 *${deadline60}*\n\n` +
    `Mohon dipantau perkembangan tindak lanjut oleh terperiksa.`;
  const footer = `\n- Sistem Irbansus Inspektorat Kab. Tasikmalaya`;
  return [header, "", body, footer].join("\n");
}

export const JENIS_LABELS = {
  T0: "T+0 — Penerbitan LHP",
  H15: "H-15 — Peringatan",
  H7: "H-7 — Mendesak",
  H3: "H-3 — Final",
  H0: "H+0 — Jatuh Tempo",
  H1: "H+1 — Eskalasi",
  PENYERAHAN: "Penyerahan Laporan — Terperiksa",
  PENYERAHAN_TIM: "Penyerahan Laporan — Tim Internal",
};

export const JENIS_SEQUENCE = ["T0", "H15", "H7", "H3", "H0", "H1"];
